import React from "react"
import camelCase from "lodash/camelCase"

import RichText from "legacy/components/shared/RichText/RichText"
import { Element, Image } from "legacy/components/shared/base"
import { LinkSwitch } from "legacy/components/Redesign/Link"
import { Maybe } from "types/Maybe"
import { SideBySideType } from "types/shared-components"
import { Title } from "legacy/components/Redesign/Title/Title"

export type SideBySideProps = {
  data: Maybe<SideBySideType>
}

const setImageWidth = (image_size: string): string => {
  let imageWidth = ""
  switch (image_size) {
    case "large":
      imageWidth = "120px"
      break
    case "medium":
      imageWidth = "96px"
      break
    default:
      imageWidth = "160px"
  }
  return imageWidth
}

export const SideBySide: React.FC<SideBySideProps> = ({
  data,
}): React.ReactElement | null => {
  const { items, primary } = data
  if (!items || !primary) return null

  const { background, mobile_alignment, side_by_side_title, title_size } =
    primary

  const title = side_by_side_title?.text

  const bgColor = background ? camelCase(background) : "lightWool"

  return (
    <Element bg={bgColor} px="sm" py={["md", "xlg"]}>
      <Element maxWidth="footerWidth" mx="auto">
        {title && (
          <Title
            mb={["sm", "lg"]}
            textAlign="center"
            title={title}
            titleSize={title_size}
          />
        )}
        <Element
          color="offBlack"
          display={["block", "grid"]}
          fontFamily="prospectus"
          fontSize={["28", "44"]}
          fontWeight="700"
          gridGap="sm"
          gridTemplateColumns={items.length === 1 ? "1fr" : "1fr 1fr"}
          lineHeight={["34px", "56px"]}
          mb={["sm", "lg"]}
          textAlign="center"
        >
          {items.map((item, index) => {
            const {
              button_style,
              button_text,
              button_type,
              button_url,
              image,
              image_size,
              side_by_side_intro,
              side_title,
            } = item
            const imageHeight = image?.dimensions?.height
            const imageWidth = image?.dimensions?.width

            return (
              <Element
                bg="white"
                display={["block", "grid"]}
                gridTemplateColumns={["none", "1fr 1fr"]}
                key={index}
                pb={["md", "lg"]}
                pt={["sm", "lg"]}
                px={["sm", "md"]}
                textAlign={mobile_alignment ? mobile_alignment : "left"}
              >
                <Element
                  alignItems="center"
                  display={["block", "grid"]}
                  mb={["sm", "0"]}
                  mx="auto"
                  textAlign={["left", "center"]}
                >
                  {image?.alt && image?.url && (
                    <Image
                      aspectRatio={`${imageWidth} / ${imageHeight}`}
                      imageData={{
                        alt: image.alt,
                        url: image.url,
                      }}
                      width={["96px", setImageWidth(image_size)]}
                    />
                  )}
                </Element>
                <Element>
                  {side_title && (
                    <Element
                      color="offBlack"
                      fontFamily="prospectus"
                      fontSize={["20", "24"]}
                      fontWeight="700"
                      lineHeight={["25px", "30px"]}
                      mb="sm"
                    >
                      {side_title}
                    </Element>
                  )}
                  {side_by_side_intro?.richText && (
                    <RichText
                      color="offBlack"
                      fontFamily="martel"
                      fontSize={["15", "16"]}
                      fontWeight="400"
                      lineHeight={["23px", "26px"]}
                      mb="sm"
                      render={side_by_side_intro?.richText}
                    />
                  )}
                  {button_text && button_url?.url && (
                    <LinkSwitch
                      linkType={button_type}
                      buttonType={button_type}
                      mt={button_style === "secondary" ? "sm" : ["md", "lg"]}
                      url={button_url}
                      variant={button_style}
                    >
                      {button_text}
                    </LinkSwitch>
                  )}
                </Element>
              </Element>
            )
          })}
        </Element>
      </Element>
    </Element>
  )
}
